export class FormItem {
  key: any;
  required: boolean;
  requiredDefault: boolean;
  type;
  visible: boolean;
  visibleDefault: boolean;
  visibleText: string;
  enum;
}
